import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const duplicateAdminBom = createAsyncThunk(
    "/admin/duplicate-bom",
    async ({ id, payload = {} }) => {
        try {
            const myurl = `${V_URL}/believe/duplicate-bom/${id}`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to clone BOM");
            }
        } catch (error) {
            console.error("Error in duplicateAdminBom:", error);
            toast.error(error.response?.data?.message || "Failed to duplicate BOM");
            throw error;
        }
    }
);

const duplicateAdminBomSlice = createSlice({
    name: "duplicateAdminBom",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(duplicateAdminBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(duplicateAdminBom.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(duplicateAdminBom.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default duplicateAdminBomSlice.reducer;
